export default __webpack_public_path__ + "static/media/selectLocation.e129b925.svg";